/**
 * CONFIDENTIAL AND PROPRIETARY SOURCE CODE.
 *
 * Use and distribution of this code is subject to applicable licenses and the
 * permission of the code owner. This notice does not indicate the actual or
 * intended publication of this source code.
 *
 * Portions developed for Bronner's Christmas by BTM Global Consulting LLC and are the
 * property of Bronner's Christmas.
 * =============================================================================
 * Version  Date          Author        Remarks
 * 1.0.0    23 Jun 2021   Tuan Le       Bug 44454 - [Bronner] [SBOX] Retail Site - Pass form data to Evergage
 */

// @module BTM.EvergageFormData.EvergageFormData
define('BTM.EvergageFormData.EvergageFormData.View'
,	[
	'btm_evergageformdata_evergageformdata.tpl'
	,	'Backbone'
    ]
, function (
	btm_evergageformdata_evergageformdata_tpl
	,	Backbone
)
{
    'use strict';

	// @class BTM.EvergageFormData.EvergageFormData.View @extends Backbone.View
	return Backbone.View.extend({

		template: btm_evergageformdata_evergageformdata_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new EvergageFormDataModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return BTM.EvergageFormData.EvergageFormData.View.Context
	,	getContext: function getContext()
		{
			//@class BTM.EvergageFormData.EvergageFormData.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
